import api from './api';
import { GET, miscRoutes, POST } from '../constants/api';

export const getAllHomePageGroups = () =>
  api({
    method: GET,
    url: miscRoutes.GET_ALL_HOME_PAGE_LINK_GROUPS,
  });

export const setHomePageLinkGroups = data =>
  api({
    method: POST,
    data,
    url: miscRoutes.SET_HOME_PAGE_LINK_GROUPS,
  });
